<script>
export default {
    name: 'IlluDateFavorite',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-date-favorite"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M50 14H14a4 4 0 00-4 4v28a4 4 0 004 4h32a8 8 0 008-8V18a4 4 0 00-4-4zM10 24h44m-34.5-5V9m25 10V9M32 19V9"
                :stroke="secondaryColor" class="secondary-color"
                stroke-linecap="round"
            />
            <path d="M53.5 43H51a4 4 0 00-4 4v.364h0V49.5" :stroke="secondaryColor" class="secondary-color" />
            <path
                d="M32 40.933l-4.039 2.925a.742.742 0 01-1.061-.202.83.83 0 01-.103-.684l1.41-4.922-3.906-3.115a.823.823 0 01-.145-1.119.752.752 0 01.59-.314l4.91-.117 1.624-4.85c.14-.417.575-.636.972-.49.22.08.391.26.468.49l1.624 4.85 4.91.117c.422.01.755.375.746.816a.81.81 0 01-.3.617l-3.907 3.115 1.41 4.922c.122.423-.108.868-.511.994a.735.735 0 01-.653-.108L32 40.933z"
                :fill="primaryColor" class="primary-color"
            />
        </g>
    </svg>
</template>
